import React from 'react';
import { addSampleGirls, updateGirlsWithNewFields, updateGirlsWithSubscriptionPlans, clearAllGirls, clearAllSystemData } from '../../utils/firestoreSetup';
import { addRealGirlsData, updateRealGirlsData } from '../../utils/realDataSetup';
import { debugGirlData, displayGirlDataTable } from '../../utils/debugUtils';
import { updateAeDataToMatchProfile, updateAllGirlsDataToMatchProfile } from '../../utils/directDataUpdate';

const DataUpdatePanel = () => {
  const handleAddSampleGirls = async () => {
    if (window.confirm('ต้องการเพิ่มข้อมูลตัวอย่างน้องๆ หรือไม่?')) {
      await addSampleGirls();
    }
  };

  const handleUpdateGirls = async () => {
    if (window.confirm('ต้องการอัพเดทข้อมูลน้องๆ ให้มีฟิลด์ใหม่หรือไม่?')) {
      await updateGirlsWithNewFields();
    }
  };

  const handleClearAllGirls = async () => {
    if (window.confirm('⚠️ ต้องการล้างข้อมูลน้องๆ ทั้งหมดหรือไม่? การกระทำนี้ไม่สามารถย้อนกลับได้!')) {
      await clearAllGirls();
    }
  };

  const handleAddRealGirls = async () => {
    if (window.confirm('ต้องการเพิ่มข้อมูลน้องๆ จริงหรือไม่?')) {
      await addRealGirlsData();
    }
  };

  const handleUpdateRealGirls = async () => {
    if (window.confirm('ต้องการอัพเดทข้อมูลน้องๆ จริงหรือไม่?')) {
      await updateRealGirlsData();
    }
  };

  const handleClearAllSystemData = async () => {
    if (window.confirm('⚠️ ต้องการลบข้อมูลทั้งหมดของระบบหรือไม่?\n\nจะลบข้อมูล:\n• น้องๆ\n• การจอง\n• ผู้ใช้\n• รูปภาพ (ใน Firestore)\n• การอนุมัติ\n• แผนทริป\n• ธุรกรรมเหรียญ\n• รายได้\n• การแจ้งเตือน\n• คำขอทีม\n• คำขอ role\n\nจะลบรูปภาพใน Storage:\n• รูปภาพน้องๆ\n• รูปโปรไฟล์\n• รูปย่อ\n• รูปที่อนุมัติแล้ว\n\nเก็บไว้เฉพาะ: Subscription Plans\n\nการกระทำนี้ไม่สามารถย้อนกลับได้!')) {
      await clearAllSystemData();
    }
  };

  const handleDebugGirlData = async () => {
    console.log('🔍 เริ่มตรวจสอบข้อมูลน้องๆ...');
    await debugGirlData();
    await displayGirlDataTable();
    alert('ตรวจสอบข้อมูลเสร็จแล้ว! ดูผลลัพธ์ใน Console (F12)');
  };

  const handleUpdateGirlsWithSubscriptionPlans = async () => {
    if (window.confirm('ต้องการอัพเดทข้อมูลน้องๆ ด้วย Subscription Plans หรือไม่?\n\nจะอัพเดท:\n• เอ๊ะ ดีแต่ปาก → Premium\n• ฝ้าย น่างับ → Premium\n• น้องใหม่ → VIP\n• น้องอื่นๆ → Free')) {
      await updateGirlsWithSubscriptionPlans();
    }
  };

  const handleUpdateAeDataToMatchProfile = async () => {
    if (window.confirm('ต้องการอัพเดทข้อมูลเอ๊ะ ดีแต่ปากให้ตรงกับหน้า profile หรือไม่?\n\nจะอัพเดท:\n• subscription: premium\n• description: เล่นได้ ดื่มเก่ง\n• bio: เล่นได้ ดื่มเก่ง\n• type: vn\n• grades: 4')) {
      const success = await updateAeDataToMatchProfile();
      if (success) {
        alert('อัพเดทข้อมูลเอ๊ะ ดีแต่ปากสำเร็จ! รีเฟรชหน้าเว็บเพื่อดูผลลัพธ์');
      } else {
        alert('เกิดข้อผิดพลาดในการอัพเดทข้อมูล');
      }
    }
  };

  const handleUpdateAllGirlsDataToMatchProfile = async () => {
    if (window.confirm('ต้องการอัพเดทข้อมูลทั้งหมดให้ตรงกับหน้า profile หรือไม่?\n\nจะอัพเดท:\n• เอ๊ะ ดีแต่ปาก → Premium, เล่นได้ ดื่มเก่ง\n• ฝ้าย น่างับ → Premium, สาวน่ารัก หน้าตาดี\n• น้องใหม่ → VIP, สาวแกร่ง ใจดี')) {
      const success = await updateAllGirlsDataToMatchProfile();
      if (success) {
        alert('อัพเดทข้อมูลทั้งหมดสำเร็จ! รีเฟรชหน้าเว็บเพื่อดูผลลัพธ์');
      } else {
        alert('เกิดข้อผิดพลาดในการอัพเดทข้อมูล');
      }
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow border">
      <h2 className="text-xl font-semibold mb-4">🔧 จัดการข้อมูลน้องๆ</h2>
      
      <div className="space-y-4">
        {/* ข้อมูลจริง */}
        <div className="bg-green-50 border border-green-200 rounded-lg p-4">
          <h3 className="font-semibold text-green-900 mb-2">🎯 เพิ่มข้อมูลจริง</h3>
          <p className="text-green-700 text-sm mb-3">
            เพิ่มข้อมูลน้องๆ จริง (เอ๊ะ ดีแต่ปาก, ฝ้าย น่างับ, น้องใหม่) เข้าสู่ Firestore
          </p>
          <button
            onClick={handleAddRealGirls}
            className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition mr-2"
          >
            เพิ่มข้อมูลจริง
          </button>
          <button
            onClick={handleUpdateRealGirls}
            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
          >
            อัพเดทข้อมูลจริง
          </button>
        </div>

        {/* ข้อมูลตัวอย่าง */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <h3 className="font-semibold text-blue-900 mb-2">📝 เพิ่มข้อมูลตัวอย่าง</h3>
          <p className="text-blue-700 text-sm mb-3">
            เพิ่มข้อมูลน้องๆ ตัวอย่างจาก sampleGirls.js เข้าสู่ Firestore
          </p>
          <button
            onClick={handleAddSampleGirls}
            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
          >
            เพิ่มข้อมูลตัวอย่าง
          </button>
        </div>

        <div className="bg-green-50 border border-green-200 rounded-lg p-4">
          <h3 className="font-semibold text-green-900 mb-2">🔄 อัพเดทข้อมูล</h3>
          <p className="text-green-700 text-sm mb-3">
            อัพเดทข้อมูลน้องๆ ที่มีอยู่แล้วให้มีฟิลด์ใหม่ (subscription, description, momoName)
          </p>
          <button
            onClick={handleUpdateGirls}
            className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition mr-2"
          >
            อัพเดทข้อมูล
          </button>
          <button
            onClick={handleUpdateGirlsWithSubscriptionPlans}
            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition mr-2"
          >
            อัพเดท Subscription Plans
          </button>
          <button
            onClick={handleUpdateAeDataToMatchProfile}
            className="px-4 py-2 bg-green-700 text-white rounded-lg hover:bg-green-800 transition mr-2"
          >
            🔧 แก้ไขเอ๊ะ ดีแต่ปาก
          </button>
          <button
            onClick={handleUpdateAllGirlsDataToMatchProfile}
            className="px-4 py-2 bg-green-800 text-white rounded-lg hover:bg-green-900 transition mr-2"
          >
            🔧 แก้ไขข้อมูลทั้งหมด
          </button>
          <button
            onClick={handleDebugGirlData}
            className="px-4 py-2 bg-green-900 text-white rounded-lg hover:bg-green-950 transition"
          >
            🔍 Debug ข้อมูล
          </button>
        </div>

        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <h3 className="font-semibold text-red-900 mb-2">🗑️ ล้างข้อมูลทั้งหมด</h3>
          <p className="text-red-700 text-sm mb-3">
            ⚠️ ลบข้อมูลน้องๆ ทั้งหมดออกจาก Firestore (ไม่สามารถย้อนกลับได้)
          </p>
          <button
            onClick={handleClearAllGirls}
            className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition mr-2"
          >
            ล้างข้อมูลน้องๆ
          </button>
          <button
            onClick={handleClearAllSystemData}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
          >
            ลบข้อมูลระบบทั้งหมด
          </button>
        </div>
      </div>

      <div className="mt-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
        <h3 className="font-semibold text-yellow-900 mb-2">💡 คำแนะนำ</h3>
        <ul className="text-yellow-800 text-sm space-y-1">
          <li>• <strong>ข้อมูลจริง:</strong> ใช้ "เพิ่มข้อมูลจริง" สำหรับข้อมูลน้องๆ จริง</li>
          <li>• <strong>อัพเดทข้อมูลจริง:</strong> อัพเดทข้อมูลที่มีอยู่แล้วให้ตรงกับข้อมูลจริง</li>
          <li>• <strong>ข้อมูลตัวอย่าง:</strong> ใช้สำหรับทดสอบระบบเท่านั้น</li>
          <li>• <strong>อัพเดทข้อมูล:</strong> เพิ่มฟิลด์ใหม่ให้ข้อมูลที่มีอยู่</li>
          <li>• <strong>ล้างข้อมูลน้องๆ:</strong> ลบเฉพาะข้อมูลน้องๆ</li>
          <li>• <strong>ลบข้อมูลระบบทั้งหมด:</strong> ลบข้อมูลทั้งหมดของระบบ + รูปภาพใน Storage (เก็บไว้เฉพาะ Subscription Plans)</li>
          <li>• หลังจากดำเนินการเสร็จ ให้รีเฟรชหน้าเว็บเพื่อดูผลลัพธ์</li>
        </ul>
      </div>
    </div>
  );
};

export default DataUpdatePanel;
